import { useEffect, useRef } from 'react'

export const useClickAway = (effect: () => void) => {
  const node = useRef<HTMLInputElement>(null)

  const handler = (event: Event) => {
    const { target } = event

    if (node && node.current) {
      if (node.current.contains(target as Node)) return

      effect()
    }
  }

  useEffect(() => {
    globalThis.document.addEventListener('mousedown', handler)
    return () => {
      globalThis.document.removeEventListener('mousedown', handler)
    }
  }, [])

  return node
}
